import ApplicationSerializer from 'nightwatch-web/serializers/application';

export default class SiteAuditCrawlingSession extends ApplicationSerializer {
  serializeIntoHash(data, type, record, options) {
    super.serializeIntoHash(data, type, record, options);
    data['crawling_session'] = data['site_audit/crawling_session'];
  }
}
